"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var v4_1 = __importDefault(require("uuid/v4"));

var enums_1 = require("../enums");

var store_1 = require("../store");

var ToastNotificationService =
/** @class */
function () {
  function ToastNotificationService() {
    this.defaultDuration = 9000;
  }

  ToastNotificationService.prototype.warnAction = function (message) {
    return store_1.addToastNotificationActionCreator({
      message: message,
      id: v4_1.default(),
      type: enums_1.ToastNotificationTypeEnum.warning,
      duration: this.defaultDuration,
      position: enums_1.ToastNotificationPositionEnum.top
    });
  };

  ToastNotificationService.prototype.infoAction = function (message) {
    return store_1.addToastNotificationActionCreator({
      message: message,
      id: v4_1.default(),
      type: enums_1.ToastNotificationTypeEnum.info,
      duration: this.defaultDuration,
      position: enums_1.ToastNotificationPositionEnum.top
    });
  };

  ToastNotificationService.prototype.successAction = function (message) {
    return store_1.addToastNotificationActionCreator({
      message: message,
      id: v4_1.default(),
      type: enums_1.ToastNotificationTypeEnum.success,
      duration: this.defaultDuration,
      position: enums_1.ToastNotificationPositionEnum.top
    });
  };

  ToastNotificationService.prototype.errorAction = function (message) {
    return store_1.addToastNotificationActionCreator({
      message: message,
      id: v4_1.default(),
      type: enums_1.ToastNotificationTypeEnum.error,
      duration: this.defaultDuration,
      position: enums_1.ToastNotificationPositionEnum.top
    });
  };

  return ToastNotificationService;
}();

exports.ToastNotificationService = ToastNotificationService;